// extracted by mini-css-extract-plugin
export default {"tagWrapper":"TagListCopy_tagWrapper__0pzk+","tag":"TagListCopy_tag__t-Syj"};